<ng-container *ngIf="secondaryElement" [attr.data-qa]="'secondaryElement'">
<div class="row">
  <div class="col-xs-7 col-sm-12 col-md-7">
    <p class="h4 secondary-title product-subtitle" [attr.data-qa]="'secondaryElement-p'">
      <span class="flex-container">
        <span class="prod-title pr-2">
          <span [innerHtml]="secondaryElement.title"></span>
          <pru-tooltip *ngIf="secondaryElement.titleToolTip && secondaryElement.title" class="title-tooltip" 
            [definitionID]="secondaryElement.titleToolTip.definitionID | toolTipType: productTypeCode ? productTypeCode : ''"
            [definitionLocation]="secondaryElement.titleToolTip.definitionLocation" 
            [clickTitle]="secondaryElement.title | toolTipFormat"
            [analyticData]="secondaryElement.title" 
            [screenReaderText]="secondaryElement.title" 
            [title]="secondaryElement.titleToolTip.title" 
            [description]="secondaryElement.titleToolTip.description">
          </pru-tooltip>
        </span>
        <span *ngIf="secondaryElement.accountAction">
          <a class="unbold" [href]="secondaryElement.accountAction.actionTarget" [attr.data-qa]="'secondaryElement-accountAction-link'">
            {{secondaryElement.accountAction.actionTitle}}
            <span class="sr-only"> {{secondaryElement.title}}</span>
          </a>
        </span>
      </span>
      <span *ngIf="secondaryElement.titleDesc" class="title-desc unbold mt-1">
        <span [innerHtml]="secondaryElement.titleDesc"></span>
      </span>
    </p>
  </div>
  <div class="col-xs-5 col-sm-12 col-md-5">

    <p class="h4 secondary-val" [attr.data-qa]="'secondaryElement-secondary-val'">
      <span class="valuetrend" *ngIf="secondaryElement.valueTrend && +secondaryElement.value">
        <span aria-hidden="true" class="fa" [ngClass]="secondaryElement.valueTrend.toLowerCase()==='positive' && +secondaryElement.value > 0 ? 'fa-arrow-up text-success' : secondaryElement.valueTrend.toLowerCase()==='negative' && +secondaryElement.value < 0? 'fa-arrow-down text-danger' : ''">
        </span>
        <span class="sr-only" *ngIf="secondaryElement.valueTrend && secondaryElement.valueTrend.toLowerCase()=='positive'">up</span>
        <span class="sr-only" *ngIf="secondaryElement.valueTrend && secondaryElement.valueTrend.toLowerCase()=='Negative'">down</span>
      </span>
      <span *ngIf="secondaryElement.valueType && secondaryElement.valueType.toLowerCase() == 'percentage' && secondaryElement.value " [ngClass]="secondaryElement.valueTrend ? secondaryElement.valueTrend.toLowerCase()==='positive' && +secondaryElement.value > 0 ? 'text-success' : secondaryElement.valueTrend.toLowerCase()==='negative' && +secondaryElement.value < 0 ? 'text-danger' : '' :''">
        {{secondaryElement.value | number:'1.2-2'}}%
      </span>
      <span *ngIf="secondaryElement.valueType && secondaryElement.valueType.toLowerCase() == 'amount'" [innerHtml]="secondaryElement.value | currency:'USD':'symbol-narrow':'1.2-2'"></span>
      <span *ngIf="secondaryElement.valueType && secondaryElement.valueType.toLowerCase() == 'restrictedamount'" [innerHtml]="secondaryElement.value | currency:'USD':'symbol-narrow':'1.2-2'">
      </span>
      <span *ngIf="secondaryElement.valueType && secondaryElement.valueType.toLowerCase() == 'notavailable'">
        <span class="alert-warning alert-text">Data N/A</span>
        <span class="sr-only">Data N/A</span>
      </span>
      <span class="product-subtitle" *ngIf="secondaryElement.valueType && ['restrictedamount', 'amount','notavailable','percentage'].indexOf(secondaryElement.valueType.toLowerCase()) < 0">
        <!-- 'restrictedamount'
                                    && secondaryElement.valueType.toLowerCase() != 'amount' && secondaryElement.valueType.toLowerCase() != 'notavailable' && secondaryElement.valueType.toLowerCase() != 'percentage')"-->
        {{secondaryElement.value}}
      </span>
      <span class="smaller" *ngIf="secondaryElement.descPos && (secondaryElement.descPos.toLowerCase() == 'inline'|| secondaryElement.descPos.toLowerCase() == 'inlinebox')"
        [ngClass]="{'inlinebox':(secondaryElement.descPos.toLowerCase() == 'inlinebox')}"> {{secondaryElement.valueDesc}}</span>
      <span class="smallercontractid block-item" *ngIf="secondaryElement.descPos && secondaryElement.descPos.toLowerCase() == 'block'">{{secondaryElement.valueDesc}}</span>
      <pru-tooltip *ngIf="secondaryElement.valueToolTip && secondaryElement.value" [definitionID]="secondaryElement.valueToolTip.definitionID | toolTipType: productTypeCode ? productTypeCode : ''"
        [definitionLocation]="secondaryElement.valueToolTip.definitionLocation" [clickTitle]="secondaryElement.valueToolTip.clickTitle || (secondaryElement.value | toolTipFormat)"
        [analyticData]="secondaryElement.title" [screenReaderText]="secondaryElement.value">
      </pru-tooltip>
    </p>
  </div>
</div>
</ng-container>